import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = {
  key: 1,
  class: "inline-flex items-center justify-center rounded-full bg-wrh-blue-400"
}
const _hoisted_3 = { class: "t-14b text-white" }
const _hoisted_4 = {
  key: 2,
  class: "inline-block rounded-full overflow-hidden bg-wrh-blue-400"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-full w-full text-white",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" })
], -1)
const _hoisted_6 = [
  _hoisted_5
]

import type { PropType } from 'vue';
import { computed, toRef } from 'vue';

// const props = defineProps({
//   user: {
//     type: Object as PropType<Partial<Homebuyer> | Partial<Admin> | null>,
//     required: false,
//   },
// })


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const user = {
  displayName: 'Leonard cooper',
  photoURL: 'https://images.unsplash.com/photo-1593085512500-5d55148d6f0d?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Y2FydG9vbnxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&w=1000&q=80',
};

const photoURL = computed(() => user.photoURL);
const displayName = computed(() => user.displayName);
const initials = computed(() => displayName.value?.split(' ')?.map((w) => w.slice(0, 1))?.join('').toUpperCase());

return (_ctx: any,_cache: any) => {
  return (_unref(photoURL))
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "inline-block rounded-full",
        src: _unref(photoURL),
        alt: user?.displayName || 'avatar'
      }, null, 8, _hoisted_1))
    : (_unref(initials))
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(initials)), 1)
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
}
}

})